import { useAsync } from '@nxsys/hooks/useAsync';
import {
  approveExpenseEmployeeApi,
  calculateExpenseTotalApi,
  cisVerifyApi,
  createAttachmentOrderEmployeeApi,
  createBIKEmployeeApi,
  createDeductionEmployeeApi,
  createDocumentEmployeeApi,
  createEmployeeApi,
  createExpenseEmployeeApi,
  createMessageEmployeeApi,
  createNoteEmployeeApi,
  createPaymentEmployeeApi,
  createReplyMessageEmployeeApi,
  deleteBIKEmployeeApi,
  deleteDocumentEmployeeApi,
  deleteNoteEmployeeApi,
  deleteSubcontractorApi,
  downloadP60EmployeeApi,
  downloadPayslipEmployeeApi,
  getPayslipDetailApi,
  getPayslipHistoryApi,
  exportAllEmployeeApi,
  exportEmployeeApi,
  fetchSmartPensionApi,
  getBackOfficeByEmployeeIdApi,
  getBankInformationByEmployeeIdApi,
  getEmployeeByIdApi,
  getExpensePotEmployeeApi,
  getEmployeeTimesheetValueByIdApi,
  createEmployeeTimesheetValueByIdApi,
  getPayrollSettingByEmployeeIdApi,
  getPensionByEmployeeIdApi,
  getYTDValueByEmployeeIdApi,
  rejectExpenseEmployeeApi,
  resendLoginIdMultipleApi,
  sendEmailP60EmployeeApi,
  sendOnboardingApi,
  submitExpenseEmployeeApi,
  updateAttachmentOrderEmployeeApi,
  updateBackOfficeByEmployeeIdApi,
  updateBankByEmployeeIdApi,
  updateBIKEmployeeApi,
  updateDeductionEmployeeApi,
  updateDocumentEmployeeApi,
  updateEmployeeByIdApi,
  updateHolidayPayBalanceByIdApi,
  updateNoteEmployeeApi,
  updateOnHoldEmployeeApi,
  updatePaymentEmployeeApi,
  updatePensionByEmployeeIdApi,
  updateSettingEmployeeByIdApi,
  getEmployeeIrelandPrivatePensionApi,
  getAvailableCompanyPensionSettingsApi,
  createEmployeeIrelandPrivatePensionApi,
  updateEmployeeIrelandPrivatePensionApi,
  deleteEmployeeIrelandPrivatePensionApi,
  toggleActiveEmployeeIrelandPrivatePensionApi,
  getRPNListByEmployeeIdApi,
  updateRPNByEmployeeIdApi,
  createRPNEmployeesApi,
} from '@nxsys/services/api';
import {
  ApproveExpenseEmployeeParams,
  ApproveExpenseEmployeeResponse,
  CalculateExpenseTotalParams,
  CalculateExpenseTotalResponse,
  CisVerifyParams,
  CisVerifyResponse,
  CreateAttachmentOrderEmployeeParams,
  CreateAttachmentOrderEmployeeResponse,
  CreateBIKEmployeeParams,
  CreateBIKEmployeeResponse,
  CreateDeductionEmployeeParams,
  CreateDeductionEmployeeResponse,
  CreateDocumentEmployeeParams,
  CreateDocumentEmployeeResponse,
  CreateExpenseEmployeeParams,
  CreateExpenseEmployeeResponse,
  CreateMessageEmployeeParams,
  CreateMessageEmployeeResponse,
  CreateNoteEmployeeParams,
  CreateNoteEmployeeResponse,
  CreatePaymentEmployeeParams,
  CreatePaymentEmployeeResponse,
  CreateReplyMessageEmployeeParams,
  CreateReplyMessageEmployeeResponse,
  DeleteBIKEmployeeResponse,
  DeleteDocumentEmployeeResponse,
  DeleteNoteEmployeeResponse,
  DeleteSubcontractorParams,
  DeleteSubcontractorResponse,
  DownloadP60EmployeeParams,
  DownloadP60EmployeeResponse,
  DownloadPayslipEmployeeResponse,
  ExportAllEmployeeParams,
  ExportAllEmployeeResponse,
  ExportEmployeeParams,
  ExportEmployeeResponse,
  FetchSmartPensionParams,
  FetchSmartPensionResponse,
  GetBackOfficeByEmployeeIdResponse,
  GetBankInformationByEmployeeIdResponse,
  GetEmployeeByIdResponse,
  GetExpensePotEmployeeParams,
  GetExpensePotEmployeeResponse,
  GetPayslipDetailResponse,
  GetPayslipHistoryResponse,
  GetPayrollSettingByEmployeeIdResponse,
  GetPensionByEmployeeIdResponse,
  GetYTDValueByEmployeeIdParams,
  GetYTDValueByEmployeeIdResponse,
  RejectExpenseEmployeeParams,
  RejectExpenseEmployeeResponse,
  ResendLoginIdMultipleParams,
  ResendLoginIdMultipleResponse,
  SendOnboardingParams,
  SendOnboardingResponse,
  SendEmailP60EmployeeParams,
  SendEmailP60EmployeeResponse,
  SubmitExpenseEmployeeParams,
  SubmitExpenseEmployeeResponse,
  UpdateAttachmentOrderEmployeeParams,
  UpdateAttachmentOrderEmployeeResponse,
  UpdateBackOfficeByEmployeeIdParams,
  UpdateBackOfficeByEmployeeIdResponse,
  UpdateBankByEmployeeIdParams,
  UpdateBankByEmployeeIdResponse,
  UpdateBIKEmployeeParams,
  UpdateBIKEmployeeResponse,
  UpdateDeductionEmployeeParams,
  UpdateDeductionEmployeeResponse,
  UpdateDocumentEmployeeParams,
  UpdateDocumentEmployeeResponse,
  UpdateEmployeeByIdParams,
  UpdateEmployeeByIdResponse,
  UpdateHolidayPayBalanceByIdParams,
  UpdateHolidayPayBalanceByIdResponse,
  UpdateNoteEmployeeParams,
  UpdateNoteEmployeeResponse,
  UpdateOnHoldEmployeeParams,
  UpdateOnHoldEmployeeResponse,
  UpdatePaymentEmployeeParams,
  UpdatePaymentEmployeeResponse,
  UpdatePensionByEmployeeIdParams,
  UpdatePensionByEmployeeIdResponse,
  UpdateSettingEmployeeByIdParams,
  UpdateSettingEmployeeByIdResponse,
  CreateEmployeeResponse,
  CreateEmployeeParams,
  GetEmployeeIrelandPrivatePensionResponse,
  GetAvailableCompanyPensionSettingsResponse,
  CreateEmployeeIrelandPrivatePensionParams,
  CreateEmployeeIrelandPrivatePensionResponse,
  UpdateEmployeeIrelandPrivatePensionParams,
  UpdateEmployeeIrelandPrivatePensionResponse,
  GetAgencyTimesheetValueByIdParams,
  GetAgencyTimesheetValueByIdResponse,
  CreateAgencyTimesheetValueByIdParams,
  CreateAgencyTimesheetValueByIdResponse,
} from '@nxsys/types/api';
import { IEmployeeIrelandPrivatePension } from '@nxsys/types/models/pension';
import { showMessage } from '@nxsys/utils/message';
import { useEffect } from 'react';
import { getErrorMessage } from '@nxsys/utils/getErrorMessage';

export const useExportEmployee = () => {
  const { value, loading, error, run } = useAsync<
    ExportEmployeeResponse,
    ExportEmployeeParams
  >(exportEmployeeApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useExportAllEmployee = () => {
  const { value, loading, error, run } = useAsync<
    ExportAllEmployeeResponse,
    ExportAllEmployeeParams
  >(exportAllEmployeeApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useResendLoginIdMultiple = () => {
  const { value, loading, error, run } = useAsync<
    ResendLoginIdMultipleResponse,
    ResendLoginIdMultipleParams
  >(resendLoginIdMultipleApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useDeleteSubcontractor = () => {
  const { value, loading, error, run } = useAsync<
    DeleteSubcontractorResponse,
    DeleteSubcontractorParams
  >(deleteSubcontractorApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useSendOnboarding = () => {
  const { value, loading, error, run } = useAsync<
    SendOnboardingResponse,
    SendOnboardingParams
  >(sendOnboardingApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

// NX-5657: the BE resolves CIS verify with HTTP 200 and {success:false,
// data:<serialized exception>} when HMRC rejects — response.message holds
// the HMRC error(s) as a string, one {Text} object, or an array of them.
const getCisVerifyErrorMessage = (data: any): string => {
  const message = data?.response?.message;
  if (Array.isArray(message)) {
    const texts = message
      .map((item: any) => item?.Text)
      .filter(Boolean)
      .join('.\n');
    if (texts) return texts;
  }
  if (typeof message === 'string' && message) return message;
  if (message?.Text) return message.Text;
  return 'CIS verification failed. Please check the subcontractor details and try again.';
};

export const useCisVerify = () => {
  const { value, loading, error, run } = useAsync<
    CisVerifyResponse,
    CisVerifyParams
  >(cisVerifyApi);

  useEffect(() => {
    if (!value) return;
    if (value.success) {
      showMessage({
        type: 'success',
        content: 'Subcontractor was verified successfully!',
      });
    } else {
      showMessage({
        type: 'error',
        content: getCisVerifyErrorMessage(value.data),
      });
    }
  }, [value]);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useFetchSmartPension = () => {
  const { value, loading, error, run } = useAsync<
    FetchSmartPensionResponse,
    FetchSmartPensionParams
  >(fetchSmartPensionApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useUpdateOnHoldEmployee = () => {
  const { value, loading, error, run } = useAsync<
    UpdateOnHoldEmployeeResponse,
    UpdateOnHoldEmployeeParams & { id: string }
  >(({ id, ...params }) => updateOnHoldEmployeeApi(id, params));
  const _run = (id: string, params: UpdateOnHoldEmployeeParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useGetEmployeeById = () => {
  const { value, loading, error, run } = useAsync<
    GetEmployeeByIdResponse,
    string
  >(getEmployeeByIdApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useUpdateEmployeeById = () => {
  const { value, loading, error, run } = useAsync<
    UpdateEmployeeByIdResponse,
    UpdateEmployeeByIdParams & { id: string }
  >(({ id, ...params }) => updateEmployeeByIdApi(id, params));
  const _run = (id: string, params: UpdateEmployeeByIdParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useGetBankInformationByEmployeeId = () => {
  const { value, loading, error, run } = useAsync<
    GetBankInformationByEmployeeIdResponse,
    string
  >(getBankInformationByEmployeeIdApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useUpdateBankByEmployeeId = () => {
  const { value, loading, error, run } = useAsync<
    UpdateBankByEmployeeIdResponse,
    UpdateBankByEmployeeIdParams & { id: string }
  >(({ id, ...params }) => updateBankByEmployeeIdApi(id, params));
  const _run = (id: string, params: UpdateBankByEmployeeIdParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useGetPayrollSettingByEmployeeId = () => {
  const { value, loading, error, run } = useAsync<
    GetPayrollSettingByEmployeeIdResponse,
    string
  >(getPayrollSettingByEmployeeIdApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useUpdateSettingEmployeeById = () => {
  const { value, loading, error, run } = useAsync<
    UpdateSettingEmployeeByIdResponse,
    UpdateSettingEmployeeByIdParams & { id: string }
  >(({ id, ...params }) => updateSettingEmployeeByIdApi(id, params));
  const _run = (id: string, params: UpdateSettingEmployeeByIdParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useUpdateHolidayPayBalanceById = () => {
  const { value, loading, error, run } = useAsync<
    UpdateHolidayPayBalanceByIdResponse,
    UpdateHolidayPayBalanceByIdParams & { id: string }
  >(({ id, ...params }) => updateHolidayPayBalanceByIdApi(id, params));
  const _run = (id: string, params: UpdateHolidayPayBalanceByIdParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useDownloadP60Employee = () => {
  const { value, loading, error, run } = useAsync<
    DownloadP60EmployeeResponse,
    DownloadP60EmployeeParams & { id: string }
  >(({ id, ...params }) => downloadP60EmployeeApi(id, params));

  const _run = (id: string, params: DownloadP60EmployeeParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useSendEmailP60Employee = () => {
  const { value, loading, error, run } = useAsync<
    SendEmailP60EmployeeResponse,
    SendEmailP60EmployeeParams & { id: string }
  >(({ id, ...params }) => sendEmailP60EmployeeApi(id, params));

  const _run = (id: string, params: SendEmailP60EmployeeParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useDeleteDocumentEmployee = () => {
  const { value, loading, error, run } = useAsync<
    DeleteDocumentEmployeeResponse,
    { id: string; employeeId: string }
  >(({ id, employeeId }) => deleteDocumentEmployeeApi(id, employeeId));
  const _run = (id: string, employeeId: string) => {
    return run({ id, employeeId });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useCreateDocumentEmployee = () => {
  const { value, loading, error, run } = useAsync<
    CreateDocumentEmployeeResponse,
    CreateDocumentEmployeeParams & { id: string }
  >(({ id, ...params }) => createDocumentEmployeeApi(id, params));
  const _run = (id: string, params: CreateDocumentEmployeeParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useUpdateDocumentEmployee = () => {
  const { value, loading, error, run } = useAsync<
    UpdateDocumentEmployeeResponse,
    UpdateDocumentEmployeeParams & { id: string; employeeId: string }
  >(({ id, employeeId, ...params }) =>
    updateDocumentEmployeeApi(id, employeeId, params),
  );
  const _run = (
    id: string,
    employeeId: string,
    params: UpdateDocumentEmployeeParams,
  ) => {
    return run({ id, employeeId, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useCreateNoteEmployee = () => {
  const { value, loading, error, run } = useAsync<
    CreateNoteEmployeeResponse,
    CreateNoteEmployeeParams & { id: string }
  >(({ id, ...params }) => createNoteEmployeeApi(id, params));
  const _run = (id: string, params: CreateNoteEmployeeParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useUpdateNoteEmployee = () => {
  const { value, loading, error, run } = useAsync<
    UpdateNoteEmployeeResponse,
    UpdateNoteEmployeeParams & { id: string; employeeId: string }
  >(({ id, employeeId, ...params }) =>
    updateNoteEmployeeApi(id, employeeId, params),
  );
  const _run = (
    id: string,
    employeeId: string,
    params: UpdateNoteEmployeeParams,
  ) => {
    return run({ id, employeeId, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useDeleteNoteEmployee = () => {
  const { value, loading, error, run } = useAsync<
    DeleteNoteEmployeeResponse,
    { id: string; employeeId: string }
  >(({ id, employeeId }) => deleteNoteEmployeeApi(id, employeeId));
  const _run = (id: string, employeeId: string) => {
    return run({ id, employeeId });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useCreatePaymentEmployee = () => {
  const { value, loading, error, run } = useAsync<
    CreatePaymentEmployeeResponse,
    CreatePaymentEmployeeParams & { id: string }
  >(({ id, ...params }) => createPaymentEmployeeApi(id, params));
  const _run = (id: string, params: CreatePaymentEmployeeParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useUpdatePaymentEmployee = () => {
  const { value, loading, error, run } = useAsync<
    UpdatePaymentEmployeeResponse,
    UpdatePaymentEmployeeParams & { id: string; employeeId: string }
  >(({ id, employeeId, ...params }) =>
    updatePaymentEmployeeApi(id, employeeId, params),
  );
  const _run = (
    id: string,
    employeeId: string,
    params: UpdatePaymentEmployeeParams,
  ) => {
    return run({ id, employeeId, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useCreateDeductionEmployee = () => {
  const { value, loading, error, run } = useAsync<
    CreateDeductionEmployeeResponse,
    CreateDeductionEmployeeParams & { id: string; isIreland?: boolean }
  >(({ id, isIreland, ...params }) =>
    createDeductionEmployeeApi(id, params, isIreland),
  );
  const _run = (
    id: string,
    params: CreateDeductionEmployeeParams,
    isIreland?: boolean,
  ) => {
    return run({ id, isIreland, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useUpdateDeductionEmployee = () => {
  const { value, loading, error, run } = useAsync<
    UpdateDeductionEmployeeResponse,
    UpdateDeductionEmployeeParams & {
      id: string;
      employeeId: string;
      isIreland?: boolean;
    }
  >(({ id, employeeId, isIreland, ...params }) =>
    updateDeductionEmployeeApi(id, employeeId, params, isIreland),
  );
  const _run = (
    id: string,
    employeeId: string,
    params: UpdateDeductionEmployeeParams,
    isIreland?: boolean,
  ) => {
    return run({ id, employeeId, isIreland, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useDownloadPayslipEmployee = () => {
  const { value, loading, error, run } = useAsync<
    DownloadPayslipEmployeeResponse,
    string
  >((id) => downloadPayslipEmployeeApi(id));
  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGetPayslipDetail = () => {
  const { value, loading, error, run } = useAsync<
    GetPayslipDetailResponse,
    string
  >((selfBillId) => getPayslipDetailApi(selfBillId));
  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGetPayslipHistory = () => {
  const { value, loading, error, run } = useAsync<
    GetPayslipHistoryResponse,
    string
  >((subcontractorId) => getPayslipHistoryApi(subcontractorId));
  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGetBackOfficeByEmployeeId = () => {
  const { value, loading, error, run } = useAsync<
    GetBackOfficeByEmployeeIdResponse,
    string
  >(getBackOfficeByEmployeeIdApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useUpdateBackOfficeByEmployeeId = () => {
  const { value, loading, error, run } = useAsync<
    UpdateBackOfficeByEmployeeIdResponse,
    UpdateBackOfficeByEmployeeIdParams & { id: string }
  >(({ id, ...params }) => updateBackOfficeByEmployeeIdApi(id, params));
  const _run = (id: string, params: UpdateBackOfficeByEmployeeIdParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useCreateAttachmentOrderEmployee = () => {
  const { value, loading, error, run } = useAsync<
    CreateAttachmentOrderEmployeeResponse,
    CreateAttachmentOrderEmployeeParams
  >(createAttachmentOrderEmployeeApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useUpdateAttachmentOrderEmployee = () => {
  const { value, loading, error, run } = useAsync<
    UpdateAttachmentOrderEmployeeResponse,
    UpdateAttachmentOrderEmployeeParams & { id: string }
  >(({ id, ...params }) => updateAttachmentOrderEmployeeApi(id, params));

  const _run = (id: string, params: UpdateAttachmentOrderEmployeeParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useGetPensionByEmployeeId = () => {
  const { value, loading, error, run } = useAsync<
    GetPensionByEmployeeIdResponse,
    string
  >(getPensionByEmployeeIdApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useUpdatePensionByEmployeeId = () => {
  const { value, loading, error, run } = useAsync<
    UpdatePensionByEmployeeIdResponse,
    UpdatePensionByEmployeeIdParams & { id: string }
  >(({ id, ...params }) => updatePensionByEmployeeIdApi(id, params));

  const _run = (id: string, params: UpdatePensionByEmployeeIdParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useApproveExpenseEmployee = () => {
  const { value, loading, error, run } = useAsync<
    ApproveExpenseEmployeeResponse,
    ApproveExpenseEmployeeParams
  >(approveExpenseEmployeeApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useRejectExpenseEmployee = () => {
  const { value, loading, error, run } = useAsync<
    RejectExpenseEmployeeResponse,
    RejectExpenseEmployeeParams
  >(rejectExpenseEmployeeApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useCalculateExpenseTotal = () => {
  const { value, loading, error, run } = useAsync<
    CalculateExpenseTotalResponse,
    CalculateExpenseTotalParams & { id: string }
  >(({ id, ...params }) => calculateExpenseTotalApi(id, params));

  const _run = (id: string, params: CalculateExpenseTotalParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useCreateExpenseEmployee = () => {
  const { value, loading, error, run } = useAsync<
    CreateExpenseEmployeeResponse,
    CreateExpenseEmployeeParams & { id: string }
  >(({ id, ...params }) => createExpenseEmployeeApi(id, params));

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useCreateMessageEmployee = () => {
  const { value, loading, error, run } = useAsync<
    CreateMessageEmployeeResponse,
    CreateMessageEmployeeParams
  >(createMessageEmployeeApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useCreateReplyMessageEmployee = () => {
  const { value, loading, error, run } = useAsync<
    CreateReplyMessageEmployeeResponse,
    CreateReplyMessageEmployeeParams & { id: number }
  >(({ id, ...params }) => createReplyMessageEmployeeApi(id, params));

  const _run = (id: number, params: CreateReplyMessageEmployeeParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useCreateBIKEmployee = () => {
  const { value, loading, error, run } = useAsync<
    CreateBIKEmployeeResponse,
    CreateBIKEmployeeParams
  >(createBIKEmployeeApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useUpdateBIKEmployee = () => {
  const { value, loading, error, run } = useAsync<
    UpdateBIKEmployeeResponse,
    UpdateBIKEmployeeParams & { id: number }
  >(({ id, ...params }) => updateBIKEmployeeApi(id, params));

  const _run = (id: number, params: UpdateBIKEmployeeParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useDeleteBIKEmployee = () => {
  const { value, loading, error, run } = useAsync<
    DeleteBIKEmployeeResponse,
    number
  >(deleteBIKEmployeeApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGetYTDValueByEmployeeId = () => {
  const { value, loading, error, run } = useAsync<
    GetYTDValueByEmployeeIdResponse,
    GetYTDValueByEmployeeIdParams & { id: string }
  >(({ id, ...params }) => getYTDValueByEmployeeIdApi(id, params));

  const _run = (id: string, params: GetYTDValueByEmployeeIdParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useGetExpensePotEmployee = () => {
  const { value, loading, error, run } = useAsync<
    GetExpensePotEmployeeResponse,
    GetExpensePotEmployeeParams & { id: string }
  >(({ id, ...params }) => getExpensePotEmployeeApi(id, params));

  const _run = (id: string, params: GetExpensePotEmployeeParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useSubmitExpenseEmployee = () => {
  const { value, loading, error, run } = useAsync<
    SubmitExpenseEmployeeResponse,
    SubmitExpenseEmployeeParams
  >(submitExpenseEmployeeApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useCreateEmployee = () => {
  const { value, loading, error, run } = useAsync<
    CreateEmployeeResponse,
    CreateEmployeeParams
  >(createEmployeeApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

// Employee Ireland Private Pension Hooks
export const useGetEmployeeIrelandPrivatePension = () => {
  const { value, loading, error, run } = useAsync<
    GetEmployeeIrelandPrivatePensionResponse,
    string
  >(getEmployeeIrelandPrivatePensionApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return { value, loading, error, run };
};

export const useGetAvailableCompanyPensionSettings = () => {
  const { value, loading, error, run } = useAsync<
    GetAvailableCompanyPensionSettingsResponse,
    string
  >(getAvailableCompanyPensionSettingsApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return { value, loading, error, run };
};

export const useCreateEmployeeIrelandPrivatePension = () => {
  const { value, loading, error, run } = useAsync<
    CreateEmployeeIrelandPrivatePensionResponse,
    CreateEmployeeIrelandPrivatePensionParams & { subcontractorId: string }
  >(({ subcontractorId, ...params }) =>
    createEmployeeIrelandPrivatePensionApi(subcontractorId, params),
  );

  const _run = (
    subcontractorId: string,
    params: CreateEmployeeIrelandPrivatePensionParams,
  ) => run({ subcontractorId, ...params });

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return { value, loading, error, run: _run };
};

export const useUpdateEmployeeIrelandPrivatePension = () => {
  const { value, loading, error, run } = useAsync<
    UpdateEmployeeIrelandPrivatePensionResponse,
    UpdateEmployeeIrelandPrivatePensionParams & {
      subcontractorId: string;
      settingId: number;
    }
  >(({ subcontractorId, settingId, ...params }) =>
    updateEmployeeIrelandPrivatePensionApi(subcontractorId, settingId, params),
  );

  const _run = (
    subcontractorId: string,
    settingId: number,
    params: UpdateEmployeeIrelandPrivatePensionParams,
  ) => run({ subcontractorId, settingId, ...params });

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return { value, loading, error, run: _run };
};

export const useDeleteEmployeeIrelandPrivatePension = () => {
  const { value, loading, error, run } = useAsync<
    void,
    { subcontractorId: string; settingId: number }
  >(({ subcontractorId, settingId }) =>
    deleteEmployeeIrelandPrivatePensionApi(subcontractorId, settingId),
  );

  const _run = (subcontractorId: string, settingId: number) =>
    run({ subcontractorId, settingId });

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return { value, loading, error, run: _run };
};

export const useToggleActiveEmployeeIrelandPrivatePension = () => {
  const { value, loading, error, run } = useAsync<
    IEmployeeIrelandPrivatePension,
    { subcontractorId: string; settingId: number }
  >(({ subcontractorId, settingId }) =>
    toggleActiveEmployeeIrelandPrivatePensionApi(subcontractorId, settingId),
  );

  const _run = (subcontractorId: string, settingId: number) =>
    run({ subcontractorId, settingId });

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return { value, loading, error, run: _run };
};

// RPN hooks
export const useGetRPNListByEmployeeId = () => {
  const { value, loading, error, run } = useAsync<
    any,
    { employeeId: string } & Record<string, any>
  >(({ employeeId, ...params }) =>
    getRPNListByEmployeeIdApi(employeeId, params),
  );

  const _run = (employeeId: string, params: Record<string, any> = {}) =>
    run({ employeeId, ...params });

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return { value, loading, error, run: _run };
};

export const useUpdateRPNByEmployeeId = () => {
  const { value, loading, error, run } = useAsync<
    any,
    { employeeId: string } & Record<string, any>
  >(({ employeeId, ...params }) =>
    updateRPNByEmployeeIdApi(employeeId, params),
  );

  const _run = (employeeId: string, params: Record<string, any> = {}) =>
    run({ employeeId, ...params });

  return { value, loading, error, run: _run };
};

export const useCreateRPNEmployees = () => {
  const { value, loading, error, run } = useAsync<
    any,
    { ids: string[] }
  >(createRPNEmployeesApi);

  return { value, loading, error, run };
};

// Margin band table for a subcontractor. Deleting a row uses the shared
// `/timesheet-values/:id` endpoint, see useDeleteAgencyTimesheetValueById.
export const useGetEmployeeTimesheetValueById = () => {
  const { value, loading, error, run } = useAsync<
    GetAgencyTimesheetValueByIdResponse,
    [string, GetAgencyTimesheetValueByIdParams]
  >(([id, params]) => getEmployeeTimesheetValueByIdApi(id, params));

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useCreateEmployeeTimesheetValueById = () => {
  const { value, loading, error, run } = useAsync<
    CreateAgencyTimesheetValueByIdResponse,
    CreateAgencyTimesheetValueByIdParams & { id: string }
  >(({ id, ...params }) => createEmployeeTimesheetValueByIdApi(id, params));

  const _run = async (
    id: string,
    params: CreateAgencyTimesheetValueByIdParams,
  ) => run({ id, ...params });

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};
